import { AssetLoader } from "./AssetLoader";
import { Group } from "three";

export class AssetManager
{
	private static _instance:AssetManager;
	public static getInstance():AssetManager
	{
		return AssetManager._instance || (AssetManager._instance = new AssetManager());
	}

	private _assetLoader : AssetLoader;
	private _gltfScene  : Group;

	constructor()
	{
		this._assetLoader = new AssetLoader();
	}

	public load(url: string)
	{
		return new Promise<Group>((resolve, reject) =>
		{
			this._assetLoader.load(url, resolve);
		});
	}

	public get gltfScene()
	{
		return this._gltfScene;
	}
}